export default __webpack_public_path__ + "static/media/IGN.8ec9fa36.svg";